var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#EBEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 14.999L12.9999 11.9993L15.9996 8.99953C16.1322 8.86694 16.2067 8.6871 16.2067 8.49958C16.2067 8.31206 16.1322 8.13222 15.9996 7.99963C15.867 7.86703 15.6872 7.79254 15.4997 7.79254C15.3122 7.79254 15.1323 7.86703 14.9997 7.99963L12 10.9993L9.00028 7.99963C8.86768 7.86703 8.68784 7.79254 8.50033 7.79254C8.31281 7.79254 8.13297 7.86703 8.00037 7.99963C7.86778 8.13222 7.79328 8.31206 7.79328 8.49958C7.79328 8.6871 7.86778 8.86694 8.00037 8.99953L11.0001 11.9993L8.00037 14.999C7.86778 15.1316 7.79328 15.3114 7.79328 15.4989C7.79328 15.6864 7.86778 15.8663 8.00037 15.9989C8.13297 16.1315 8.31281 16.206 8.50032 16.206C8.68784 16.206 8.86768 16.1315 9.00028 15.9989L12 12.9992L14.9997 15.9989C15.1323 16.1315 15.3122 16.206 15.4997 16.206C15.6872 16.206 15.867 16.1315 15.9996 15.9989C16.1322 15.8663 16.2067 15.6864 16.2067 15.4989C16.2067 15.3114 16.1322 15.1316 15.9996 14.999Z",
    fill: "#2A2B2F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.eb61dc70.svg";
export { ForwardRef as ReactComponent };